// Angular
import { CanActivate, Router, ActivatedRouteSnapshot, UrlTree } from "@angular/router";
import { inject, Injectable } from "@angular/core";

// Services
import { UserService } from "#services/user/user.service";

@Injectable({
    providedIn: "root",
})
export class PermissionGuard implements CanActivate {
    private userService = inject(UserService);
    private router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const validPermission = route.data["can"] ?? null;

        if (validPermission && !this.userService.can(validPermission)) {
            return this.router.createUrlTree(["/403"]);
        }

        return true;
    }
}
